export default function StrengthsSection() {
  const strengths = [
    {
      icon: 'ri-building-4-line',
      title: '自社で宿泊施設を運営中',
      description: '現役ホストとして実際に宿泊施設を運営しているため、現場の課題や成功のポイントを熟知しています。机上の空論ではない、実務に基づいたアドバイスを提供します。'
    },
    {
      icon: 'ri-file-list-3-line',
      title: '簡易宿所申請実績あり',
      description: '東京都内での簡易宿所申請・許認可取得の実績があります。保健所や消防署との折衝経験を活かし、スムーズな開業をサポートします。'
    },
    {
      icon: 'ri-team-line',
      title: '会計事務所との連携体制',
      description: '信頼できる会計事務所と連携しており、確定申告や税務相談のサポート体制が整っています。民泊特有の会計処理もお任せください。'
    },
    {
      icon: 'ri-service-line',
      title: '運営代行と清掃まで一貫対応',
      description: 'Airbnb運営代行からゲスト対応、清掃管理まで、民泊ビジネスに必要なすべてのサービスをワンストップで提供。複数の業者を管理する手間を省きます。'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
      <div className="container mx-auto px-6">
        {/* セクションタイトル */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/20 text-emerald-700 text-sm font-bold px-5 py-2 rounded-full mb-6">
            <i className="ri-star-line text-base"></i>
            <span>Why Choose Us</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-4">
            なぜ私たちを選ぶか
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            現役ホストによる実務経験と実績に基づいた、信頼できるサポート体制
          </p>
        </div>

        {/* 強みカードグリッド */}
        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {strengths.map((strength, index) => (
            <div
              key={index}
              className="group bg-white p-8 rounded-2xl border border-slate-200 hover:border-emerald-500/50 hover:shadow-xl transition-all duration-300"
            >
              {/* アイコン */}
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-xl mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                <i className={`${strength.icon} text-3xl text-white`}></i>
              </div>

              {/* タイトル */}
              <h3 className="text-xl font-bold text-slate-900 mb-4">
                {strength.title}
              </h3>

              {/* 説明文 */}
              <p className="text-slate-600 leading-relaxed">
                {strength.description}
              </p>
            </div>
          ))}
        </div>

        {/* 信頼バッジ */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 bg-slate-900 text-white px-8 py-4 rounded-full">
            <i className="ri-shield-check-line text-2xl text-emerald-400"></i>
            <span className="text-lg font-bold">現役ホストによる実務型サポート</span>
          </div>
        </div>
      </div>
    </section>
  );
}